import { t } from "@/i18n-js/instance";
import type { AgentProp } from "@circle-react/components/SettingsApp/CommunityBot/Agents";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import workflowsEmptyStateImage from "./svgs/workflows-empty-state.svg";

export const EmptyState = ({
  agent,
  onPrimaryClick,
}: {
  agent: AgentProp;
  onPrimaryClick: () => void;
}) => (
  <div
    className="flex size-full flex-col items-center justify-center p-8 text-center"
    data-testid="empty-state"
  >
    <img
      width={134}
      height={134}
      src={workflowsEmptyStateImage}
      alt=""
      aria-hidden="true"
      loading="eager"
      className="mb-6"
    />

    <div className="flex flex-col items-center justify-center gap-5">
      <div className="flex max-w-lg flex-col gap-3">
        <Typography.TitleMd weight="font-semibold">
          {t("community_bot.bot_builder.automations_page.empty_state.title")}
        </Typography.TitleMd>
        <Typography.BodyMd>
          {t(
            "community_bot.bot_builder.automations_page.empty_state.description",
          )}
        </Typography.BodyMd>
      </div>
      <div className="flex gap-3">
        <TippyV2
          content={t(
            "community_bot.bot_builder.automations_page.empty_state.tooltip",
          )}
          placement="top"
          enabled={!agent.enabled}
        >
          <Button
            type="button"
            variant="circle"
            large
            disabled={!agent.enabled}
            onClick={onPrimaryClick}
          >
            {t(
              "community_bot.bot_builder.automations_page.empty_state.new_workflow_button",
            )}
          </Button>
        </TippyV2>
      </div>
    </div>
  </div>
);
